import { useQuery } from '@tanstack/react-query';
import { medicalRecordsApi } from '@/api';

export function useMedicalRecords(params?: {
  patientId?: string;
  doctorId?: string;
  status?: string;
  limit?: number;
  offset?: number;
}) {
  return useQuery({
    queryKey: ['medical-records', 'list', params] as const,
    queryFn: () => medicalRecordsApi.getMedicalRecords(params),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
    retry: 2,
  });
}

export function usePatientMedicalHistory(patientId: string) {
  return useQuery({
    queryKey: ['medical-records', 'patient', patientId, 'history'] as const,
    queryFn: () => medicalRecordsApi.getPatientMedicalHistory(patientId),
    enabled: !!patientId,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    retry: 2,
  });
}

export function useDoctorMedicalRecords(doctorId: string) {
  return useQuery({
    queryKey: ['medical-records', 'doctor', doctorId] as const,
    queryFn: () => medicalRecordsApi.getDoctorMedicalRecords(doctorId),
    enabled: !!doctorId,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    retry: 2,
  });
}
